if (!customElements.get("section-solar-grid")) {
    customElements.define(
      "section-solar-grid",
      class SectionSolarGrid extends HTMLElement {
        constructor() {
          super();
          this.swiperContainer = this.querySelector("swiper-component");
          setTimeout(()=>{
            this.init();
            this.initSwiper();
            this.listenerResize();
          },0)
          
        }
  
        init() {
          const _this = this;
          const itemOpens = Array.from(
            this.querySelectorAll(".solar-grid-title")
          );
          console.log('11',itemOpens.length)
          const textContents = Array.from(
            this.querySelectorAll(".solar-grid-content")
          );
          console.log('textContents',textContents.length)
          itemOpens.forEach((el, index) => {
            el.onclick = function () {
              
              const content_ = textContents[index];
              $(textContents).not(content_).removeClass("active");
              content_.classList.add("active");
              content_.querySelector(".close_icon").onclick = function () {
                content_.classList.remove("active");
              };
            };
          });
        }
  
        listenerResize() {
          const _this = this;
          $(window).on(
            "resize",
            $.debounce(150, () => {
              console.log("11111");
              _this.initSwiper();
            })
          );
        }
        initSwiper() {
          if (
            (window.innerWidth || document.documentElement.clientWidth) <= 768
          ) {
            this.swiperContainer.swiper.init();
            this.swiperContainer.swiper.enable();
          } else {
            this.swiperContainer.swiper.disable();
          }
        }
      }
    );
  }
  